import { render, staticRenderFns } from "./TimeInputDemo.vue?vue&type=template&id=5b9245fd"
import script from "./TimeInputDemo.vue?vue&type=script&lang=js"
export * from "./TimeInputDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports